import PropTypes from 'prop-types';
import { forwardRef } from 'react';
//
import getRatio from '@/components/shared/image/getRatio';

// ----------------------------------------------------------------------

// Thin image wrapper with optional aspect-ratio box. Uses the browser's
// native lazy loading (replaces react-lazy-load-image-component). The
// `effect`/`disabledEffect` props are accepted for backward compatibility
// but are no-ops — every call site already passes `disabledEffect`.
const Image = forwardRef(
  ({ ratio, disabledEffect, effect, sx, ...other }, ref) => {
    const content = (
      <img
        alt=""
        loading="lazy"
        className="wrapper"
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        {...other}
      />
    );

    if (ratio) {
      return (
        <span
          ref={ref}
          className="block overflow-hidden relative"
          style={{
            width: '100%',
            lineHeight: 1,
            paddingTop: getRatio(ratio),
            ...sx,
          }}
        >
          {content}
          <style>{`
            span :global(.wrapper) {
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              position: absolute;
              background-size: cover !important;
            }
          `}</style>
        </span>
      );
    }

    return (
      <span
        ref={ref}
        className="block overflow-hidden relative"
        style={{
          lineHeight: 1,
          ...sx,
        }}
      >
        {content}
        <style>{`
          span :global(.wrapper) {
            width: 100%;
            height: 100%;
            background-size: cover !important;
          }
        `}</style>
      </span>
    );
  },
);

Image.propTypes = {
  sx: PropTypes.object,
  effect: PropTypes.string,
  disabledEffect: PropTypes.bool,
  ratio: PropTypes.oneOf([
    '4/3',
    '3/4',
    '6/4',
    '4/6',
    '16/9',
    '9/16',
    '21/9',
    '9/21',
    '1/1',
  ]),
};

export default Image;
